import _ from 'lodash';

const marquee = (function() {
  function setMarquee(el) {
    // console.log(el);
    const scrollWidth = el.scrollWidth;
    const elWidth = el.offsetWidth;

    // const duration =  + 's';
    if (scrollWidth > elWidth) {
      el.style.width = scrollWidth;
      el.style.maxWidth = 'none';
      enableMarquee(el);
    } else {
      el.removeAttribute('style');
      disableMarquee(el);
    }
  }

  function enableMarquee(el) {
    el.classList.add('is-scrolling');
  }

  function disableMarquee(el) {
    el.classList.remove('is-scrolling');
  }

  function init() {
    const marqueeItems = document.querySelectorAll('.js-marquee');

    [].forEach.call(marqueeItems, item => {
      setMarquee(item);
    });

    window.addEventListener(
      'resize',
      _.debounce(() => {
        [].forEach.call(marqueeItems, item => {
          setMarquee(item);
        });
      })
    );
  }

  window.addEventListener('DOMContentLoaded', init);
})();

export default marquee;



// WEBPACK FOOTER //
// ./resources/assets/js/marquee.js